import { BrowserModule } from '@angular/platform-browser';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import * as i0 from "@angular/core";
export class RiskLookbackModule {
}
RiskLookbackModule.ɵfac = function RiskLookbackModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RiskLookbackModule)(); };
RiskLookbackModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: RiskLookbackModule });
RiskLookbackModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule, FeatureNeededModule] });
